import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const SERVICE_OPTIONS = [
  {
    value: "engine_rebuild",
    label: "Engine Rebuild",
    desc: "Full teardown, inspection, and rebuild of two-stroke and four-stroke motocross engines.",
  },
  {
    value: "custom_bike_build",
    label: "Custom Bike Build",
    desc: "Ground-up custom race and evo builds for VMXDN and private collections.",
  },
  {
    value: "aftermarket_parts_fitting",
    label: "Aftermarket Parts Fitting",
    desc: "Correct installation and setup of aftermarket parts so they perform as intended.",
  },
  {
    value: "bearing_replacement",
    label: "Bearing Replacement",
    desc: "Wheel, head race, swing arm and linkage bearings — pressed, greased, torqued.",
  },
  {
    value: "new_bike_prep",
    label: "New Bike Strip & Grease",
    desc: "Strip a brand new machine, grease every chassis bearing, and reassemble to spec.",
  },
];

export const BEARING_TYPES = [
  "Wheel bearings",
  "Head race bearings",
  "Swing arm bearings",
  "Linkage bearings",
];

export const COLLECTION_METHODS = [
  {
    value: "courier_box",
    label: "Courier — engine box to your door",
    desc: "We ship you a purpose-built box. Pack your engine, post it back. We rebuild, we ship it back.",
    icon: "package",
  },
  {
    value: "we_collect",
    label: "We collect your bike",
    desc: "Whole-bike work (custom builds, bearings, new bike prep) — we come and collect.",
    icon: "truck",
  },
];

export const STATUS_LABELS = {
  new: "New",
  in_progress: "In Progress",
  awaiting_parts: "Awaiting Parts",
  completed: "Completed",
  paid: "Paid",
  cancelled: "Cancelled",
};

export const STATUS_COLORS = {
  new: "bg-blue-500/20 text-blue-300 border-blue-500/40",
  in_progress: "bg-orange-500/20 text-orange-300 border-orange-500/40",
  awaiting_parts: "bg-yellow-500/20 text-yellow-300 border-yellow-500/40",
  completed: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  paid: "bg-green-600/20 text-green-300 border-green-600/40",
  cancelled: "bg-zinc-500/20 text-zinc-300 border-zinc-500/40",
};
